export const msalConfig = {
	clientId: '7a586fad-0dc3-4130-a4c9-79ab1700d7c4',
	tenantId: '3ba5b943-4e56-4a2f-9b91-b1f1c37d645b',
	consentScopes: ['openid', 'profile', 'email', 'offline_access', 'user.read'],
	prompt: 'select_account',
};
